<template>
    <ul>
        <menu-item v-for="item in items" :item="item" :key="item.text"></menu-item>
    </ul>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  }
};
</script>

<style scoped>
</style>
